import React from 'react';
import PropTypes from 'prop-types';
import { AuthShape } from 'lib/auth-shape';
import UserShape from 'entities/user/shape';
import Providers from './Providers';

export default function Root({
  auth,
  user,
  endpointOverrides,
  studioUrl,
  region,
  children,
}) {
  return (
    <Providers
      auth={auth}
      user={user}
      endpointOverrides={endpointOverrides}
      studioUrl={studioUrl}
      region={region}
    >
      {children}
    </Providers>
  );
}

Root.propTypes = {
  auth: AuthShape,
  user: UserShape,
  endpointOverrides: PropTypes.shape({
    customerApiUrl: PropTypes.string,
    appcuesApiUrl: PropTypes.string,
    imageServiceLambdaUrl: PropTypes.string,
  }),
  studioUrl: PropTypes.string,
  region: PropTypes.string,
  children: PropTypes.node.isRequired,
};
